import React from 'react';
import { useTheme } from 'ThemeContext';

import { Item, ItemExternal, Imagebox, Image } from './WidgetImage.style';

function WidgetImage({ data = {} }) {
  const theme = useTheme();
  const renderItemInner = data => {
    return (
      <Imagebox>
        {data.image ? (
          <Image
            theme={theme.widgetImage.image}
            src={data.image}
            loading='lazy'
            alt={data.title}
          />
        ) : (
          ''
        )}
      </Imagebox>
    );
  };

  return (
    <>
      {(data.slug && /(http(s?)):\/\//gi.test(data.slug)) ||
      (data.url && /(http(s?)):\/\//gi.test(data.url)) ||
      data.url_outside ? (
        <ItemExternal
          title={data.title}
          href={data.slug || data.link || data.url || data.url_outside}
          target={
            data._blank || data.url_blank || data.url_outside_blank
              ? '_blank'
              : '' || data.target || ''
          }
          rel={
            data.nofollow || data.url_nofollow || data.url_outside_nofollow
              ? 'nofollow'
              : '' || data.rel || ''
          }
        >
          {renderItemInner(data)}
        </ItemExternal>
      ) : (
        <Item
          title={data.title}
          smooth
          to={data.slug && data.slug[0] === '/' ? data.slug : `/${data.slug}`}
        >
          {renderItemInner(data)}
        </Item>
      )}
    </>
  );
}

export default WidgetImage;
